import React from 'react';

const DEFAULT_TEXT =
    'Ich habe die Daten geprüft und bestätige ausdrücklich, dass ich den rechtlichen Hinweis verstanden habe. Mir ist bekannt, dass es sich hierbei um ein automatisiertes Standard-Muster und keine individuelle Rechtsberatung handelt. Die Verwendung erfolgt auf eigene Gefahr und Verantwortung.';

export type PePapersDisclaimerGateProps = {
    accepted: boolean;
    onAcceptedChange: (accepted: boolean) => void;
    /** Optional längerer Rechtstext (z. B. Arbeitsvertrag) */
    text?: string;
    pulse?: boolean;
    boxRef?: React.RefObject<HTMLDivElement | null>;
    className?: string;
};

/** Amber Pflicht-Gate wie Kündigung / Unwiderrufliche Freistellung */
export const PePapersDisclaimerGate: React.FC<PePapersDisclaimerGateProps> = ({
    accepted,
    onAcceptedChange,
    text = DEFAULT_TEXT,
    pulse = false,
    boxRef,
    className = '',
}) => (
    <div
        ref={boxRef}
        className={`px-4 sm:px-6 pt-3 transition-shadow duration-300 print:hidden ${
            pulse
                ? 'ring-2 ring-amber-400 ring-offset-2 ring-offset-pe-card dark:ring-offset-[#111] rounded-xl'
                : ''
        } ${className}`}
    >
        <div
            className={`rounded-xl border-2 transition-all duration-200 ${
                accepted
                    ? 'border-emerald-500/40 bg-emerald-500/5 px-3 py-2'
                    : 'border-amber-500 bg-amber-500/15 dark:bg-amber-500/10 shadow-[0_0_24px_rgba(245,158,11,0.25)] p-3 sm:p-4'
            }`}
        >
            {!accepted && (
                <>
                    <p className="mb-1.5 sm:mb-2 text-[10px] sm:text-[11px] font-black uppercase tracking-[0.18em] text-amber-800 dark:text-amber-300">
                        Pflicht · Rechtlicher Hinweis bestätigen
                    </p>
                    <p className="mb-2 sm:mb-3 text-[11px] sm:text-xs font-semibold text-amber-950 dark:text-amber-100/95 leading-snug">
                        Ohne diese Bestätigung bleiben PDF-Download, Druck und Archiv-Speichern gesperrt.
                    </p>
                </>
            )}
            <label className="flex items-start gap-3 cursor-pointer group">
                <input
                    type="checkbox"
                    checked={accepted}
                    onChange={(e) => onAcceptedChange(e.target.checked)}
                    className="mt-0.5 w-5 h-5 shrink-0 cursor-pointer appearance-none bg-pe-input dark:bg-black border-2 border-amber-600 dark:border-amber-400 rounded checked:bg-[#E6C299] checked:border-[#E6C299] relative transition-colors after:content-['✔'] after:absolute after:text-black after:text-[11px] after:font-black after:left-1/2 after:top-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:opacity-0 checked:after:opacity-100"
                />
                <span
                    className={
                        accepted
                            ? 'text-xs sm:text-sm font-semibold text-emerald-800 dark:text-emerald-300 leading-snug'
                            : 'text-xs sm:text-sm text-pe-text dark:text-slate-200 leading-relaxed group-hover:text-black dark:group-hover:text-white transition-colors'
                    }
                >
                    {accepted ? 'Rechtlicher Hinweis bestätigt' : text}
                </span>
            </label>
        </div>
    </div>
);

export default PePapersDisclaimerGate;
